import { Pipe, PipeTransform } from '@angular/core';
import { Question } from "@bequeathed/ngx-services";

@Pipe({
    name: 'sortGroupedQuestions',
    standalone: true
})
export class SortGroupedQuestionsPipe implements PipeTransform {

    transform(value: Question[]): Question[] {
        value
            .filter((question: Question) => question.groupedQuestions)
            .forEach((question: Question) => {
                const idList: string[] = []
                question.questions!.forEach((question: Question) => idList.push(question.id!))
                question.groupedQuestions?.forEach((groupedQuestions, index) => {
                    const orderedList: Question[] = []
                    groupedQuestions.forEach((groupQuestion: Question) => {
                        const orderedIndex = idList.findIndex((id: string) => groupQuestion.id!.endsWith(id))
                        orderedList[orderedIndex] = groupQuestion
                    })
                    question.groupedQuestions!.set(index, orderedList.filter(question => question != null))
                })
            })

        return value;
    }

}
